import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const DEFAULT_FREE_SHIPPING_THRESHOLD = 500;

/**
 * Free shipping threshold (per vendor) in ILS.
 * Configurable from the admin settings tab (`free_shipping_threshold`).
 * A value of 0 disables free shipping entirely.
 */
export function useFreeShippingThreshold(): number {
  const { data } = useQuery({
    queryKey: ["free-shipping-threshold"],
    queryFn: async () => {
      const { data } = await supabase
        .from("platform_settings")
        .select("value")
        .eq("key", "free_shipping_threshold")
        .maybeSingle();
      const raw = data?.value as unknown;
      const num = typeof raw === "number" ? raw : parseFloat(String(raw ?? ""));
      return Number.isFinite(num) ? num : DEFAULT_FREE_SHIPPING_THRESHOLD;
    },
    staleTime: 5 * 60_000,
  });
  return data ?? DEFAULT_FREE_SHIPPING_THRESHOLD;
}

/** True when the vendor subtotal qualifies for free shipping. */
export function qualifiesForFreeShipping(subtotal: number, threshold: number): boolean {
  return threshold > 0 && subtotal >= threshold;
}
